import React, { FunctionComponent, SVGProps } from 'react';

import styled from 'styled-components';

export interface TracWalletIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const TracWalletIcon: FunctionComponent<TracWalletIconProps> = ({
  className,
  ...props
}) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    className={className || ''}
    {...props}
  >
    <Path d="M14,0V7L7,0V7L0,0V12l4,4v-7l7,7v-7l7,7V3.7L14,0Z" />
  </svg>
);

export default TracWalletIcon;

const Path = styled.path`
  fill: ${({ theme }) => theme.colors.accent};
`;
